<script lang="ts">
	import { Button, IconButton, Text, Container } from '@Shelly/shelly-design-system';
	import { createEventDispatcher } from 'svelte';
	import { format } from '../../../../../services/i18n';
	import ConditionPreviewWithControls from '../../../components/GenericView/ConditionPreviewWithControls.svelte';
	import SectionContainer from '../../../components/GenericView/SectionContainer.svelte';
	export let whens = [];

	const andDisplayList = (andArr: unknown[]) => {
		if (!Array.isArray(andArr)) return [];
		const andList = andArr as { r?: string; rr?: string }[];
		return andList
			.map((condition, realIndex) => ({ condition, realIndex }))
			.filter(({ condition }) => {
				const ref =
					(condition as { r?: string; rr?: string })?.r ?? (condition as { rr?: string })?.rr;
				return typeof ref !== 'string' || !ref.endsWith(':channel');
			});
	};

	const dispatch = createEventDispatcher();
</script>

<Container padding="scrollPaddings">
	<Text styleType="h2" class="mb-s">{$format('scene_preview_when')}</Text>

	<!--
	List of all whens parsed from sdr format to ui data and dispatch add,edit and delete events
-->
	<!--Note: the it must be key to handle each change properly, without display old index values-->
	{#key whens}
		{#each whens as single_el, main_ind (single_el)}
			{@const displayList = andDisplayList(single_el.and)}
			<SectionContainer>
				{#each displayList as item, displayIndex (item.realIndex)}
					<ConditionPreviewWithControls
						element={item.condition}
						type={'and'}
						self_ind={item.realIndex}
						{main_ind}
						on:delete
						on:edit
					/>
					{#if displayIndex < displayList.length - 1}
						<Text class="text-center mt-s mb-s" styleType="body-small">
							{$format('and')}
						</Text>
					{/if}
				{/each}
				<div class="text-center mt-s">
					<IconButton
						icon="far fa-plus"
						variant="secondary"
						on:click={(e) => {
							e.stopPropagation();
							dispatch('add', { type: 'and', main_ind, sub_ind: -1 });
						}}
					>
						{$format('button_add_condition', {
							default: 'Add condition',
						})}
					</IconButton>
				</div>
			</SectionContainer>
			{#if main_ind < whens.length}
				<Text class="text-center mt-s mb-s">{$format('or')}</Text>
			{/if}

			{#if main_ind === whens.length - 1}
				<div class="mt-s text-center">
					<Button
						variant="secondary"
						size="m"
						on:click={(e) => {
							e.stopPropagation();
							dispatch('add', { type: 'or', main_ind: -1, sub_ind: -1 });
						}}
					>
						{$format('button_add_condition', {
							default: 'Add condition',
						})}
					</Button>
				</div>
			{/if}
		{/each}
	{/key}
</Container>
